import React from "react";
import { Container } from "semantic-ui-react";
import SafeFunLogo from "../../assets/sf-logo.svg";

const AppHeader = () => {
  return (
    <Container
      fluid
      style={{
        display: "flex",
        height: "76px",
        backgroundColor: "#1AACD9",
        alignItems: "center",
        marginBottom: "20px",
        paddingLeft: "22px",
      }}
    >
      <img
        className="ui small rounded image"
        alt="SafeFun Logo"
        src={SafeFunLogo}
        style={{
          display: "inline-block",
        }}
      ></img>
    </Container>
  );
};

export default AppHeader;
